import React, { useEffect, useState } from "react";
import "./SupplierDetailedView.scss";
import { Box, Button, Card, Chip } from "@mui/material";
import {
  getSupplierDetails,
  sendRegistrationRequest,
} from "../../../services/srmService";
import { Avatar, Steps } from "antd";
import PersonIcon from "@mui/icons-material/Person";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import moment from "moment";
import { toastMessage } from "../../../helper";
import { neutral } from "../../../constants/colorConstants";

function SupplierDetailedView(props: any) {
  let [supplierData, setSupplierData] = useState<any>({});
  const onClose = props.onClose;
  const onPrev = props.onPrev;
  const onNext = props.onNext;
  const activeIndex = props.activeIndex;
  const limit = props.limit;
  const page = props.page;
  const totalCount = props.totalCount;
  const getFormattedDate = (date: any) => {
    return moment(new Date(date)).format("Do MMM YYYY hh:mm A");
  };
  const emissionCaptureMap: any = {
    "scope-1-2": "Scope 1 and 2",
    "scope-1-2-3": "Scope 1, 2 and specific scope 3 categories",
    product: "Product carbon footprint",
  };
  const sendRegistrationLink = (supplierId: any) => {
    sendRegistrationRequest(supplierId).then((res) => {
      if (res.status == 200)
        toastMessage("Request sent successfully", "success");
      loadSupplierData();
    });
  };

  const loadSupplierData = () => {
    setSupplierData({});
    setRequestText("");
    getSupplierDetails(props.supplierId).then((res) => {
      if (res.data["status_history"].length) {
        res.data["status_history"] = res.data["status_history"].sort(
          (a: any, b: any) => {
            a = new Date(a.created);
            b = new Date(b.created);
            return a > b ? 1 : a < b ? -1 : 0;
          }
        );
        let lastStatus =
          res.data["status_history"][res.data["status_history"].length - 1]
            .status;
        if (lastStatus == "Created") {
          setRequestText("Request Registration");
          res.data["status_history"].push({
            status: "Send a request to register",
          });
        } else if (
          lastStatus == "Registration request sent" ||
          lastStatus == "Registration request sent again"
        ) {
          setRequestText("Request Again");
          res.data["status_history"].push({
            status: "Request has not been accepted yet",
          });
        }
      }
      setSupplierData(res.data);
    });
  };
  let [requestText, setRequestText] = useState("");
  const editSupplier = () => {
    window.location.href =
      window.location.origin +
      "/partners/suppliers/create?supplier=" +
      supplierData.id;
  };
  useEffect(() => {
    loadSupplierData();
  }, [props.supplierId]);

  return (
    <div className="flex flex-col px-4 pw-detailed-view-main">
      <Box sx={{ position: "absolute", top: "-3rem", right: "0%" }}>
        <div className="flex flex-row items-center gap-6 p-2 px-4">
          <div className="w-full flex justify-end gap-3 pr-2">
            {!supplierData.activation_date ? (
              <Button
                onClick={editSupplier} //(e) => editSupplier()}
                sx={{
                  border: `1px solid ${neutral[300]}`,
                  fontSize: "12px",
                  textTransform: "none",
                  padding: "5px 15px !important",
                }}
              >
                <CreateIcon
                  className="text-neutral-900"
                  sx={{ height: "1.25rem", marginRight: "5px" }}
                ></CreateIcon>
                <span className="text-neutral-900 font-bold">Edit</span>
              </Button>
            ) : (
              ""
            )}
            {activeIndex + page * limit > 0 && (
              <div
                onClick={() => onPrev()}
                className="pw-navigate-next pw-padding-5"
              >
                <img src="assets/icons/prev.svg" alt=" " />
              </div>
            )}
            {activeIndex + page * limit < totalCount - 1 && (
              <div
                onClick={() => onNext()}
                className="pw-navigate-next pw-padding-5 pw-bunit-next"
              >
                <img src="assets/icons/next.svg" alt=" " />
              </div>
            )}

            <div
              onClick={() => onClose()}
              className="pw-navigate-next items-center"
            >
              <CloseIcon className=" items-center text-neutral-600" />
            </div>
          </div>
        </div>
      </Box>
      {Object.keys(supplierData).length > 0 ? (
        <Box
          width={"50vw"}
          padding={"20px 0px 0px 20px"}
          overflow={"auto"}
          height={"80vh"}
          marginTop={"-25px"}
        >
          <Card
            className="pw-supplier-details"
            variant="outlined"
            style={{ padding: "20px" }}
          >
            <div className="flex flex-row items-center gap-x-5">
              <Avatar
                style={{ height: "120px", width: "120px" }}
                src={supplierData.logo}
              />
              <div className="flex-1">
                <div className="flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center gap-x-3">
                    <span id="pw-e2e-dv-companyname" className="text-xl">
                      {supplierData.name}
                    </span>
                    <span style={{ color: "#596981" }}>
                      {" "}
                      {supplierData.address?.city}
                    </span>
                  </div>
                  <div id="pw-e2e-dv-supplierStatus">
                    {supplierData.disabled ? (
                      <span style={{ color: "#8897AE" }}>Inactive</span>
                    ) : (
                      <span style={{ color: "#59CE90", fontWeight: "bold" }}>
                        Active
                      </span>
                    )}
                  </div>
                </div>
                <hr style={{ margin: "10px 0px" }} />
                <div className="flex flex-row items-center justify-between">
                  <div className="text-center">
                    <span
                      id="pw-e2e-dv-primaryContactName"
                      style={{ color: "#1D2025" }}
                    >
                      {" "}
                      <PersonIcon style={{ marginRight: "10px" }} /> Primary
                      Contact - {supplierData.contact_name}
                    </span>
                  </div>
                  <Chip
                    id="pw-e2e-dv-supplierRegistrationStatus"
                    label={
                      supplierData.activation_date
                        ? "Registered"
                        : "Unregistered"
                    }
                    sx={{
                      backgroundColor: supplierData.activation_date
                        ? "#EEF6ED"
                        : "#EAEEF4",
                      fontWeight: "bold",
                      color: supplierData.activation_date
                        ? "#70A268"
                        : "#3D4A5C",
                    }}
                  />
                </div>
              </div>
            </div>

            <table>
              <tr>
                <td>Type</td>
                <td id="pw-e2e-dv-suppliertype">
                  {" "}
                  {supplierData.isSupplier
                    ? supplierData.isBorrower
                      ? "Supplier,Borrower"
                      : "Supplier"
                    : "Borrower"}
                </td>
              </tr>
              <tr>
                <td>Registration ID</td>
                <td id="pw-e2e-dv-supplierRegistrationId">
                  {" "}
                  {supplierData.registration_id}
                </td>
              </tr>
              <tr>
                <td>Industry Type</td>
                <td id="pw-e2e-supIndustryType">
                  {supplierData.parent_industry_code +
                    "/" +
                    supplierData.child_industry}
                </td>
              </tr>
              <tr>
                <td>Contact name</td>
                <td id="pw-e2e-dv-supplierContactName">
                  {supplierData.contact_name}
                </td>
              </tr>
              <tr>
                <td>Email ID</td>
                <td id="pw-e2e-dv-supplierContactMail">{supplierData.email}</td>
              </tr>

              <tr>
                <td>Contact no.</td>
                <td id="pw-e2e-dv-supplierContactNumber">
                  {supplierData.dial_code + " " + supplierData.phone}
                </td>
              </tr>
              <tr>
                <td> Secondary contact name</td>
                <td id="pw-e2e-dv-supplierContactName">
                  {supplierData.secondary_contact_name}
                </td>
              </tr>
              <tr>
                <td>Secondary contact email ID</td>
                <td id="pw-e2e-dv-supplierContactMail">
                  {supplierData.secondary_email}
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td id="pw-e2e-dv-supplierAddress">
                  {supplierData.address?.addressLine}
                </td>
              </tr>
              <tr>
                <td>Frequency of data request</td>
                <td id="pw-e2e-dv-supplierFrequencyOfDataRequest">
                  {supplierData.preferences?.frequency}
                </td>
              </tr>
              <tr>
                <td>Report Window</td>
                <td id="pw-e2e-dv-supplierReportWindow">
                  {supplierData.preferences?.report_window}days
                </td>
              </tr>
              <tr>
                <td>Emissions Captured</td>
                <td id="pw-e2e-dv-supplierEmissionsCaptured">
                  {supplierData.preferences?.emissions_captured
                    ? emissionCaptureMap[
                        supplierData["preferences"]["emissions_captured"]
                      ]
                    : ""}
                </td>
              </tr>
              {supplierData["custom_fields"].map((field: any) => {
                return (
                  <tr>
                    <td id={`pw-e2e-${field.name}`}>{field.name}</td>
                    <td id={`pw-e2e-${field.name}-fieldvalue`}>
                      {field.value}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td>Remarks</td>
                <td id="pw-e2e-detailViewRemarks">{supplierData.remarks}</td>
              </tr>
            </table>
          </Card>
          {supplierData["status_history"].length > 0 ? (
            <Card style={{ marginTop: "15px", padding: "20px", width: "50%" }}>
              Status History
              <Steps
                current={
                  requestText
                    ? supplierData["status_history"].length - 2
                    : supplierData["status_history"].length
                }
                items={supplierData["status_history"].map((item: any) => {
                  return {
                    title: item.status,
                    description: item.created ? (
                      getFormattedDate(item.created)
                    ) : (
                      <Button
                        onClick={() => sendRegistrationLink(supplierData.id)}
                        sx={{ textTransform: "none", cursor: "pointer" }}
                        variant="outlined"
                      >
                        {requestText}
                      </Button>
                    ),
                  };
                })}
                progressDot
                direction="vertical"
              />
            </Card>
          ) : (
            ""
          )}
        </Box>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
}

export default SupplierDetailedView;
